import { useCallback, useEffect } from "react";

const KEY_NAME_ESC = "Escape"; // no itx
const KEY_EVENT_TYPE = "keyup"; // no itx

export default function useEscapeKey(handleClose: any) {
  const handleEscKey = useCallback(
    (event: any) => {
      if (event.key === KEY_NAME_ESC) {
        handleClose();
      }
    },
    [handleClose],
  );

  useEffect(() => {
    document.addEventListener(KEY_EVENT_TYPE, handleEscKey, false);

    return () => {
      document.removeEventListener(KEY_EVENT_TYPE, handleEscKey, false);
    };
  }, [handleEscKey]);
}
